"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageReseller = exports.ResellerName = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.ResellerName = (0, flora_react_1.styled)(flora_react_1.Text, {
    paddingLeft: '$2',
    fontWeight: '$medium',
    maxWidth: '18ch',
    wordWrap: 'break-word',
    textAlign: 'left',
});
exports.ImageReseller = (0, flora_react_1.styled)(flora_react_1.Image, {
    borderRadius: '$pill',
    borderColor: '$backgroundAltSecondary',
    borderWidth: '$thin',
    borderStyle: 'solid',
});
